module.exports = __webpack_public_path__ + "media/images/giphy_attribution_white-db5179ffa51d5b8644e0f75517aae0d2.png";